module.exports = __webpack_public_path__ + "static/media/ProfileStep1.1f2568b7.svg";